import { render } from "./ClassItem.vue?vue&type=template&id=92b01f64"
import script from "./ClassItem.vue?vue&type=script&lang=js"
export * from "./ClassItem.vue?vue&type=script&lang=js"

import "./ClassItem.vue?vue&type=style&index=0&id=92b01f64&lang=scss"
script.render = render

export default script